
export const API_GET_LAYOUT = 'layout_data';

export const apiGetLayout = (params,onSuccess,onFailure) => ({
    type: API_GET_LAYOUT,
    payload: {
        params,
        onSuccess,
        onFailure
    },
});
